import React from 'react';
import Button from '../../../../components/Button/Button';
import { PortalWithState } from 'react-portal';
import SetAssignedToModal from './SetAssignedToModal';
import { IdArrayInput } from '../../../../hooks/useTablePages';

type WaterSitesActionsProps = { ids: IdArrayInput };

const WaterSitesActions: React.FC<WaterSitesActionsProps> = ({
  ids,
}): JSX.Element => {
  return (
    <>
      <PortalWithState closeOnOutsideClick closeOnEsc>
        {({ openPortal, closePortal, portal }) => (
          <>
            <Button
              variant="outline"
              disabled={!ids.length}
              icon="person"
              onClick={openPortal}
            >
              Assign
            </Button>
            {portal(<SetAssignedToModal ids={ids} onClose={closePortal} />)}
          </>
        )}
      </PortalWithState>
    </>
  );
};

export default WaterSitesActions;
